export default "__VITE_ASSET__BXBxF11e__"